import { dispatcher, api } from 'react-structure-admin';

export const CATEGORY = 'CATEGORY';
export const CATEGORY_FETCH = 'CATEGORY_FETCH';
export const CATEGORY_FETCH_FINISHED = 'CATEGORY_FETCH_FINISHED';

export const fetchTree = (resource, params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource,
    actionType: CATEGORY_FETCH,
    effect: async () => api.fetch(`${resource}/tree`, { ...params })
  });
};
